export const TIME_REMAINING_FIELD_NAME = 'log-work-time-remaining';
export const TIME_SPENT_FIELD_NAME = 'log-work-time-spent';
export const DATE_STARTED_FIELD_NAME = 'log-work-date-field';
export const DESCRIPTION_FIELD_NAME = 'log-work-description';
